import Styles from './card.module.scss';
import React, { useState, useEffect } from 'react';
import CheckBoxRoundedIcon from '@mui/icons-material/CheckBoxRounded';
import CheckBoxOutlineBlankRoundedIcon from '@mui/icons-material/CheckBoxOutlineBlankRounded';

const EnrollViewCard = ({ checkHybridStatus = false, ...props }) => {
	const [enrolled, setEnrolled] = useState(false);

	function streamClick(streamId) {
		setEnrolled(!enrolled);
		props.handleStreamSelection(streamId);
	}
	// eslint-disable-next-line react-hooks/exhaustive-deps
	useEffect(() => {
		if (props?.selectedLabs?.has(props.data.id)) {
			setEnrolled(true)
		}
	})
	useEffect(() => {
		if (props.resetSelections) {
			setEnrolled(false);
		}
	}, [props.resetSelections]);

	return (
		<div className={Styles.container}
			style={{
				backgroundColor: enrolled ? "#b9f6ca" : "#fff",
				transition: "background-color 0.5s ease",
				opacity: ((checkHybridStatus && props.data?.status !== 'active') || props.maxSelected) & !enrolled ? 0.5 : 1,
				pointerEvents: ((checkHybridStatus && props.data?.status !== 'active') || props.maxSelected) & !enrolled ? "none" : "",
			}}
			onClick={() => { streamClick(props.data.id) }}
		>
			{/* Image Part */}
			< div className={Styles.imageContainer} >
				<img src={`${process.env.REACT_APP_GLOBAL_MEDIA_URL}${props.data.icon}`} className={Styles.courseImage} alt="courseImg" />
			</div >
			{/* Content Part */}
			< div className={Styles.contentContainer} >
				<p className={Styles.headerText}>{props.data.name}</p>
				<p className={Styles.descriptionText}>{props.data.descr}</p>
			</div >
			{/*Button  Part */}
			{!(props.data?.org_purchase && props.data?.status !== 'active') &&
				< div className={Styles.buttonContainer} >
					<button
						className={Styles.startButton}
						style={{
							// backgroundColor: enrolled ? "rgb(56, 50, 130)" : "rgb(0, 74, 173)"
						}}
						variant="contained">
						{enrolled ? <CheckBoxRoundedIcon fontSize='large' sx={{ color: 'rgb(0, 74, 173)' }} /> : <CheckBoxOutlineBlankRoundedIcon sx={{ color: 'rgb(0, 74, 173)' }} />}
					</button>
				</div >
			}
		</div >
	);
};

export default EnrollViewCard;
